import React from 'react'
import { Link } from 'react-router-dom';
import {LazyLoadImage, trackWindowScroll} from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/blur.css';
class HideInfoPage extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
        };
    }
    
    render() {
        return (

            <div className="err404contbx">
                <LazyLoadImage
                    effect="blur"
                    src={!this.props.deletePost ? "https://cdn.dscovr.com/BGOverlay.webp" : "https://cdn.dscovr.com/images/deletedPost.webp"}
                    onError={(e)=>{e.target.onerror = null; e.target.src=!this.props.deletePost ? "https://cdn.dscovr.com/BGOverlay.png" : "https://cdn.dscovr.com/images/deletedPost.png"}}
                    className="img-fluid" alt="Error image"/>
                <span className="divider_1"/>
                {!this.props.deletePost ? <>
                    <h2>You have hidden the content of this page. </h2>
                    <Link to="/hidden-content/feeds" className='btn unHideViewbtn'>Unhide</Link>
                    <p>to view the content</p>
                </> : <><h2>This {this.props.projectDelete ? "Project" : this.props.studioDelete ? "Studio" : "Post"} No Longer Exists</h2></>}
            </div>
        );

    }
}

export default HideInfoPage
